import { createSelector } from 'reselect';
import { ArmyListUnitCreateView } from '@Selectors/builder/myArmyList/make/unit/new/view/ArmyListUnitCreateView';
import {
  AvailableUnitCategoryView,
  AvailableUnitView,
} from '@Selectors/builder/myArmyList/make/unit/new/view/AvailableUnitCategoryView';
import { getArsenaUnits } from '@Selectors/arsenal/selector/getArsenaUnits';
import { getArsenalArmyIsLoading } from '@Selectors/arsenal/selector/getArsenalArmyIsLoading';
import { getUnitCategories } from '@Selectors/arsenal/selector/getUnitCategories';

export const ArsenalUnitNewPresenter = createSelector(
  [getArsenaUnits, getArsenalArmyIsLoading, getUnitCategories],
  (usedUnits, arsenalLoading, units): ArmyListUnitCreateView => {
    return new ArmyListUnitCreateView({
      units: units
        .filter((u) => !usedUnits.some((unit) => unit.unitCategoryId === u.id))
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(
          (u) =>
            ({
              id: 0,
              label: '',
              options: [
                {
                  id: u.id,
                  name: u.name,
                  points: 0,
                  favoriteUnits: [],
                } satisfies AvailableUnitView as AvailableUnitView,
              ],
            }) satisfies AvailableUnitCategoryView as AvailableUnitCategoryView,
        ),
      isLoading: arsenalLoading,
      canSubmit: !arsenalLoading,
    });
  },
);
